import moment from "moment";
import { drivingLessonStatus } from "../../utils/config";

export default function LessonEvent({ event, categoryList }) {
  const isBooked = !!event.student_id;
  const currentStatus = drivingLessonStatus[event.lesson_status];
  const category =
    categoryList.find((c) => Number(c.id) === Number(event.category_id)) || {};
  const auto = event.auto;
  // Цвет текста меняется в зависимости от того, занят слот или нет
  const textColor = isBooked ? "#fff" : "#333";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        fontSize: "11px",
        lineHeight: "1.2",
        padding: "2px",
        color: textColor,
      }}>
      <div
        style={{
          fontWeight: "bold",
          borderBottom: `1px solid ${isBooked ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.1)"}`,
          marginBottom: "3px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        {isBooked ? (
          <strong style={{ fontSize: "12px" }}>🎓 {event.student_name}</strong>
        ) : (
          <span style={{ fontStyle: "italic", opacity: 0.8 }}>Свободно</span>
        )}
        {isBooked && <span>{currentStatus?.title} 📌</span>}
      </div>

      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}>
        {auto ? (
          <span style={{ opacity: 0.9 }}>
            🚗 {`${auto.brend} ${auto.model} ${auto.license_plate}`}
          </span>
        ) : null}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "4px",
        }}>
        <span style={{ opacity: 0.9 }}>
          👤
          {event.teacher_name?.split(" ")[0]}
        </span>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: isBooked
              ? "rgba(255,255,255,0.2)"
              : "rgba(0,0,0,0.08)",
            padding: "0 5px",
            borderRadius: "4px",
            fontSize: "10px",
            fontWeight: "bold",
            textAlign: "center",
          }}>
          {category.name || "-"}
        </span>
      </div>
    </div>
  );
}
